import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form, Pagination } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl, CastePageSize as PageSize } from "../../../Utility/constants";

const Caste = () => {
  const [subCategories, setSubCategories] = useState([]);
  //const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSubCategory, setCurrentSubCategory] = useState({
    id: 0,
    name: "",
    categoryId: "",
  });

  useEffect(() => {
    fetchSubCategories();
   // fetchCategories();
  }, []);

  const fetchSubCategories = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/CasteMaster`);
      setSubCategories(response.data);
    } catch (error) {
      toast.error("Failed to fetch Caste details");
    }
  };

  // Calculate total pages
    const totalPages = Math.ceil(subCategories.length / PageSize);
  
    // Calculate current data slice
    const currentData = subCategories.slice(
      (currentPage - 1) * PageSize,
      currentPage * PageSize
    );
  
    // Handle page change
    const handlePageChange = (page) => {
      setCurrentPage(page);
    };

  // const fetchCategories = async () => {
  //   try {
  //     const response = await axios.get(`${baseUrl}/api/CategoryMaster`);
  //     setCategories(response.data);
  //   } catch (error) {
  //     toast.error("Failed to fetch categories");
  //   }
  // };

  const handleShowModal = (subCategory = { id: 0, name: "", categoryId: "" }) => {
    setCurrentSubCategory(subCategory);
    setIsEdit(!!subCategory.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentSubCategory({ id: 0, name: "", categoryId: "" });
  };

  const handleSave = async () => {
    try {
      if (currentSubCategory.id === 0) {
        await axios.post(`${baseUrl}/api/CasteMaster`, currentSubCategory);
        toast.success("Caste details added successfully");
      } else {
        await axios.put(`${baseUrl}/api/CasteMaster/${currentSubCategory.id}`, currentSubCategory);
        toast.success("Caste details updated successfully");
      }
      fetchSubCategories();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save Caste details");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Caste details?")) {
      try {
        await axios.delete(`${baseUrl}/api/CasteMaster/${id}`);
        toast.success("Caste details deleted successfully");
        fetchSubCategories();
      } catch (error) {
        toast.error("Failed to delete Caste details");
      }
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Manage Caste</h2>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add Caste
          </Button>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
            <th>#</th>
              <th>Name</th>
              {/* <th>Category</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentData
            .sort((a,b) => a.name.localeCompare(b.name))
            .map((subCategory, index) => (
              <tr key={subCategory.id}>
                 <td>{index + 1}</td>
                <td>{subCategory.name}</td>
                {/* <td>{categories.find((c) => c.id === subCategory.categoryID)?.name}</td> */}
                <td>
                  <Button variant="warning" onClick={() => handleShowModal(subCategory)}>
                    Edit
                  </Button>{" "}
                  <Button variant="danger" onClick={() => handleDelete(subCategory.id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Controls */}
      <Pagination className="justify-content-center">
        <Pagination.First
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        />
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i}
            active={i + 1 === currentPage}
            onClick={() => handlePageChange(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
        <Pagination.Last
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        />
      </Pagination>
       
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{currentSubCategory.id === 0 ? "Add Caste" : "Edit Caste"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>            
            {/* <Form.Group>
              <Form.Label>Category</Form.Label>
              <Form.Control
                as="select"
                value={currentSubCategory.categoryID}
                onChange={(e) => setCurrentSubCategory({ ...currentSubCategory, categoryId: e.target.value })}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group> */}
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={currentSubCategory.name}
                onChange={(e) => setCurrentSubCategory({ ...currentSubCategory, name: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="primary" onClick={handleSave}>
          {isEdit ? "Update" : "Add"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
          Cancel
          </Button>
          
        </Modal.Footer>
      </Modal>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Caste;
